import React from "react";
import { useNavigate } from "react-router-dom";
import { COLOR } from "../constants/colors";
import { PrimaryButton, TransparentButton } from "./Buttons";
import tiliLogo from "../logo_transparent.png";

interface HeaderProps {
  variant?: "landing" | "listing";
  onWaitlistClick?: () => void;
}

export default function Header({ variant = "landing", onWaitlistClick }: HeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-sm" style={{ backgroundColor: `${COLOR.bg}f0` }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
        <nav className="flex justify-between items-center h-8">
          <div className="flex items-center gap-3 cursor-pointer h-8" onClick={() => navigate("/")}>
            <img src={tiliLogo} alt="Tili logo" className="h-8 w-auto block" />
          </div>
        </nav>
      </div>
    </header>
  );
}
